import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRODUCT_PRICE_ARS } from '../data/content';
import { trackPixelEvent } from '../utils/pixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  /** Where the click came from, sent to the pixel for attribution. */
  origin: string;
};
export function CtaButton({
  children,
  size = 'lg',
  className = '',
  origin
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base' : 'px-5 py-3 text-sm';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Pack Boxeo 360',
      content_type: 'product',
      currency: 'ARS',
      value: PRODUCT_PRICE_ARS,
      origin
    });
  };
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-red-600 font-semibold uppercase tracking-wide text-white shadow-lg shadow-red-900/40 transition-[background-color,transform] duration-150 ease-out hover:bg-red-700 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400 ${sizeClasses} ${className}`} data-id="element-25" data-mp="vdd95aofm78i">
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-26" data-mp="3jxqea7ptufue" />
    </a>;
}